import React, { useState, useRef } from 'react';
import { IoCloudUploadOutline } from 'react-icons/io5';
import { FaRegFileArchive } from "react-icons/fa";

const ZipUpload = ({ initialFileName, onFileSelect, height }) => {
    // Instead of a preview URL, we store the file name to show the user
    const [fileName, setFileName] = useState(initialFileName || null);
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            onFileSelect(file); // Pass the raw zip file to the parent
        }
    };

    const handleCancel = () => {
        setFileName(null);
        onFileSelect(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const triggerPicker = () => {
        fileInputRef.current.click();
    };

    return (
        <div className="thumbnail_cover" style={height ? { height: height, display: 'flex', alignItems: 'center', justifyContent: 'center' } : null}>
            {/* Hidden File Input - now accepting .zip */}
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept=".zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
            />

            <div className="thumbnail_contain" style={{ textAlign: 'center' }}>
                {fileName ? (
                    <>
                        {/* Show Zip Icon and File Name instead of Image */}
                        <FaRegFileArchive />
                        <p style={{ marginTop: '10px', fontWeight: 'bold', wordBreak: 'break-all', padding: '0 10px' }}>
                            {fileName}
                        </p>
                        <div className="button_group">
                            <button onClick={triggerPicker}>Change</button>
                            <button style={{ border: "none", color: 'red' }} onClick={handleCancel}>Remove</button>
                        </div>
                    </>
                ) : (
                    <>
                        <IoCloudUploadOutline size={50} />
                        <p>Upload the Course Resource (.zip)</p>
                        <button onClick={triggerPicker}>Select Zip File</button>
                    </>
                )}
            </div>
        </div>
    );
};

export default ZipUpload;